import { EllipsisText, Flex, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { type CancelledExamLocationRow } from '../../types';

export const adminCancelledLocationColumns: GridColDef<CancelledExamLocationRow>[] = [
  {
    field: 'province',
    headerName: 'จังหวัด',
    width: 144,
    sortable: false,
    renderCell: ({ row }) => {
      return <EllipsisText>{row.province}</EllipsisText>;
    },
  },
  {
    field: 'locationName',
    headerName: 'สถานที่สอบ / อาคาร / ชั้น',
    flex: 1,
    minWidth: 300,
    sortable: false,
    renderCell: ({ row }) => {
      return (
        <Flex sx={{ flexDirection: 'column' }}>
          <EllipsisText variant='body1Semibold'>{row.locationName}</EllipsisText>
          <EllipsisText>
            อาคาร: {row.buildingName} ชั้น: {row.floor}
          </EllipsisText>
        </Flex>
      );
    },
  },
  {
    field: 'roomName',
    headerName: 'ห้องสอบ',
    width: 300,
    sortable: false,
    renderCell: ({ row }) => {
      return (
        <Flex sx={{ flexDirection: 'column' }}>
          <EllipsisText>ห้อง: {row.roomName}</EllipsisText>
          <EllipsisText>เลขที่: {row.roomNumber}</EllipsisText>
        </Flex>
      );
    },
  },
  {
    field: 'retiredBy',
    headerName: 'ผู้ยกเลิกการใช้งาน',
    width: 200,
    sortable: false,
    renderCell: ({ row }) => {
      return <EllipsisText>{row.retiredBy}</EllipsisText>;
    },
  },
  {
    field: 'retiredAt',
    headerName: 'วันที่ยกเลิกการใช้งาน',
    width: 184,
    renderCell: ({ row }) => {
      return <EllipsisText>{formatDateTime(row.retiredAt)}</EllipsisText>;
    },
  },
];
